import React from 'react'

function EsignCord() {
    const openPopup = () => {
        const width = window.innerWidth;
        const height = window.innerHeight;
        const left = (window.screen.width - width) / 2;
        const top = (window.screen.height - height) / 2;

        window.open(
            "https://dev.dp1u35ayhja12.amplifyapp.com/",
            "EsignCoordinatesPopup",
            `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=no, width=${width}, height=${height}, top=${top}, left=${left}`
        );
    }

    return (
        <div>
            <button className="pageTitle" style={{"cursor": "pointer"}} onClick={openPopup}>
                Get your Esign Coordinates
            </button>
        </div>
    )
}

export default EsignCord
